<template>
  <div>
    <v-container grid-list-lg fluid>
        <v-layout row wrap>
        <v-flex lg12 md12 sm12 xs12>
            <v-layout row wrap>
                <v-flex lg4 md12 sm12 pr-6 pl-lg-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuStart"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedStartDateFormatted"
                                label="Từ ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 md12 sm12 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuEnd"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedEndDateFormatted"
                                label="Đến ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 md12 sm12 pr-6>
                    <v-btn @click="filter_data" color="#a41c21" outlined>Xem</v-btn>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex lg3 md12 sm12 pr-6 pl-lg-6>
                    <v-select clearable :items="puchase_staffs" item-value="ID" item-text="FullName" v-model="selectedBuyerId" label="CSKH"></v-select>
                </v-flex>
                <v-flex lg3 md12 sm12 pr-6>
                    <v-select multiple :items="orderStatus" item-value="value" item-text="name" v-model="selectedStatus" label="Trạng thái đơn"></v-select>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg12 md12 sm12 xs12>
            <v-layout row wrap>
                <v-flex lg12 md12 sm12 xs12>
                    <highcharts :options="chartOptions"></highcharts>
                </v-flex>
            </v-layout>
        </v-flex>
        
        <v-flex lg12>
            <v-card class="mb-8">
                <v-data-table fixed-header height="750px"   :headers="headers" hide-default-footer :sortable="false" :items="items" :server-items-length="items ? items.length : 0" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{item.ReportDate | display_date('DD-MM-YYYY')}}</td>
                            <td>{{ item.Username }}</td>
                            <td class="text-end">{{ item.TotalOrder | currency}}</td>
                            <td class="text-end">{{ item.TotalWeight | currency('', 2)}}</td>
                            <td class="text-end">{{ item.TotalVolume | currency('', 3)}}</td>
                            
                            <td class="text-end">{{ item.TotalWeightAmount | currency}}</td>
                            <td class="text-end">{{ item.TotalVolumeAmount | currency}}</td>
                            <td class="text-end">{{ item.TotalProductAmount | currency}}</td>
                            <td class="text-end">{{ item.TotalComplainAmount | currency}}</td>
                            <td class="text-end">{{ item.TotalRevenue | currency}}</td>
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr class="table-summary">
                            <td class="font-weight-bold" colspan="2">TỔNG</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalOrder | currency}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalWeight | currency('', 2)}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalVolume | currency('', 3)}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalWeightAmount | currency}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalVolumeAmount | currency}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalProductAmount | currency}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalComplainAmount | currency}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalRevenue | currency}}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import {Chart} from 'highcharts-vue';
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment"
export default {
    components: {
        highcharts: Chart 
    },
    data() {
        return {
            viewName: "bao-cao-loi-nhuan-khach-hang",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            orderStatus: configs.ORDER_STATUS,
            selectedStatus: [10],
            selectedBuyerId: 0,
            headers: [
                {
                text: "Ngày",
                value: "ReportDate",
                sortable: false,
                filterable: true,
                dataType: configs.DATA_TYPE["Date"]
                },
                {
                text: "Khách hàng",
                value: "Username",
                sortable: false,
                filterable: true,
                dataType: configs.DATA_TYPE["String"]
                },
                {
                text: "Tổng đơn",
                value: "TotalOrder",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Tổng cân",
                value: "TotalWeight",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Tổng khối",
                value: "TotalVolume",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Doanh thu cân",
                value: "TotalWeightAmount",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Doanh thu khối",
                value: "TotalVolumeAmount",
                sortable: false,
                filterable: true,
                align: "end",
                values: configs.DATA_TYPE["Number"]
                },
                {
                text: "Tiền báo giá",
                value: "TotalProductAmount",
                sortable: false,
                filterable: true,
                align: "end",
                values: configs.DATA_TYPE["Number"]
                },
                {
                text: "Khiếu nại đã xử lý",
                value: "TotalComplainAmount",
                sortable: false,
                filterable: true,
                align: "end",
                values: configs.DATA_TYPE["Number"]
                },
                {
                text: "Doanh thu",
                value: "TotalRevenue",
                sortable: false,
                filterable: true,
                align: "end",
                values: configs.DATA_TYPE["Number"]
                }       
            ]
        };
    },
    computed: {
        ...mapState({
            items: state => state.report.customerRevenue.data,
            loading: state => state.report.loading,
            staffs: state => state.commons.all_users,
            puchase_staffs: state =>
                _.filter(state.commons.all_users, function(o) {
                return (o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
            })
        }),
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        summary() {
            var ret = {
                'TotalOrder': _.sumBy(this.items, 'TotalOrder'),
                'TotalWeight': _.sumBy(this.items, 'TotalWeight'),
                'TotalVolume': _.sumBy(this.items, 'TotalVolume'),
                'TotalWeightAmount': _.sumBy(this.items, 'TotalWeightAmount'),
                'TotalVolumeAmount': _.sumBy(this.items, 'TotalVolumeAmount'),
                'TotalProductAmount': _.sumBy(this.items, 'TotalProductAmount'),
                'TotalComplainAmount': _.sumBy(this.items, 'TotalComplainAmount'),
                'TotalRevenue': _.sumBy(this.items, 'TotalRevenue')
            };
            return ret;
        },
        summaryByDate() {
            let byDate = _.groupBy(this.items, 'ReportDate');

            let computedData = [];
            _.forEach(byDate, function(receiptList, ReportDate){
                computedData.push({
                    'ReportDate': ReportDate,
                    'TotalOrder': _.sumBy(receiptList, 'TotalOrder'),
                    'TotalWeight': _.sumBy(receiptList, 'TotalWeight'),
                    'TotalVolume': _.sumBy(receiptList, 'TotalVolume'),
                    'TotalWeightAmount': _.sumBy(receiptList, 'TotalWeightAmount'),
                    'TotalVolumeAmount': _.sumBy(receiptList, 'TotalVolumeAmount'),
                    'TotalProductAmount': _.sumBy(receiptList, 'TotalProductAmount'),
                    'TotalComplainAmount': _.sumBy(receiptList, 'TotalComplainAmount'),
                    'TotalRevenue': _.sumBy(receiptList, 'TotalRevenue')
                });
            });

            return computedData;
        },
        chartOptions() {
            var dataChart =  _.sortBy(this.summaryByDate,'ReportDate');
            var ret = {
                chart: { type: 'line' },
                title: { text: 'Tổng doanh thu' },
                credits: { enabled: false },
                tooltip: {shared: true, pointFormat: '{series.name}: <b>{point.y:,.3f}</b><br/>'},
                xAxis: {
                    categories: _.map(dataChart, function(x) {return x.ReportDate})
                },
                yAxis: {
                    title: {
                        text: 'Tổng cộng'
                    }
                },
                plotOptions: {
                    line: {
                        dataLabels: {
                            enabled: true,
                            format: '{y:.3f}',
                        }
                    }
                },
                series: [
                    { 
                        name: 'Đơn hàng',
                        visible: false,
                        data: _.map(dataChart, 'TotalOrder')
                    },
                    { 
                        name: 'KG',
                        visible: false,
                        data: _.map(dataChart, 'TotalWeight')
                    },
                    { 
                        name: 'M3',
                        visible: false,
                        data: _.map(dataChart, 'TotalVolume')
                    },
                    { 
                        name: 'Phí KG',
                        visible: false,
                        data: _.map(dataChart, 'TotalWeightAmount')
                    },
                    { 
                        name: 'Phí M3',
                        visible: false,
                        data: _.map(dataChart, 'TotalVolumeAmount')
                    },
                    { 
                        name: 'Báo giá',
                        visible: false,
                        data: _.map(dataChart, 'TotalProductAmount')
                    },
                    { 
                        name: 'Khiếu nại',
                        visible: false,
                        data: _.map(dataChart, 'TotalComplainAmount')
                    },
                    { 
                        name: 'Doanh thu',
                        data: _.map(dataChart, 'TotalRevenue')
                    }
                ]
            };

            return ret;
        }
    },
    methods: {
        filter_data: function () {
            this.$store.dispatch("commons/getAllUsers");
            var param = {
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
                buyerid: this.selectedBuyerId | 0,
                status: this.selectedStatus
            };
            this.$store.dispatch("report/getCustomerRevenue", param);
        },
        export_data() {
            var param = {
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
                buyerid: this.selectedBuyerId | 0,
                status: this.selectedStatus
            };
            this.$store.dispatch("report/exportCustomerRevenue", param);
        }
    },
    mounted() {
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("REQUEST_CREATE_DATA", this.export_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("REQUEST_CREATE_DATA", this.export_data);
    }
};
</script>
<style scoped>
.rate-p {
    margin-bottom: 0px;
    margin-top: 16px;
}
.rate-p2 {
    margin-bottom: 16px;
    margin-top: 8px;
    color: rgb(168, 168, 168);
}
</style>